import { render, staticRenderFns } from "./CustomerShowOdontoImplant.vue?vue&type=template&id=75e65198"
import script from "./CustomerShowOdontoImplant.vue?vue&type=script&lang=js"
export * from "./CustomerShowOdontoImplant.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowOdontoImplant.vue?vue&type=style&index=0&id=75e65198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports